const ACTIVE_CHAT_CONTEXT_KEY = '__CASTICART_ACTIVE_CHAT_CONTEXT__';

const normalizeId = (value) => {
  if (value == null) return '';
  return String(value).trim();
};

const normalizeContext = (context = {}) => {
  if (!context || typeof context !== 'object' || Array.isArray(context)) {
    return null;
  }
  const scope = normalizeId(context.scope);
  const channel = normalizeId(context.channel);
  if (!scope || !channel) return null;
  return {
    owner: normalizeId(context.owner),
    scope,
    channel,
    artistId: normalizeId(context.artistId),
    eventId: normalizeId(context.eventId),
    threadId: normalizeId(context.threadId),
  };
};

export const getActiveChatContext = () => {
  if (typeof window === 'undefined') return null;
  return normalizeContext(window[ACTIVE_CHAT_CONTEXT_KEY]);
};

export const setActiveChatContext = (context) => {
  if (typeof window === 'undefined') return;
  const normalized = normalizeContext(context);
  if (!normalized) {
    delete window[ACTIVE_CHAT_CONTEXT_KEY];
    return;
  }
  window[ACTIVE_CHAT_CONTEXT_KEY] = normalized;
};

export const clearActiveChatContext = (owner = '') => {
  if (typeof window === 'undefined') return;
  const normalizedOwner = normalizeId(owner);
  if (!normalizedOwner) {
    delete window[ACTIVE_CHAT_CONTEXT_KEY];
    return;
  }
  const current = getActiveChatContext();
  if (current?.owner === normalizedOwner) {
    delete window[ACTIVE_CHAT_CONTEXT_KEY];
  }
};

export const isMatchingActiveChatContext = (activeContext, incomingContext) => {
  const active = normalizeContext(activeContext);
  const incoming = normalizeContext(incomingContext);
  if (!active || !incoming) return false;
  if (active.scope !== incoming.scope) return false;
  if (active.channel !== incoming.channel) return false;

  if (active.channel === 'personal') {
    if (active.scope === 'artist') return true;
    return Boolean(active.artistId) && active.artistId === incoming.artistId;
  }

  if (active.channel === 'group') {
    return Boolean(active.threadId) && active.threadId === incoming.threadId;
  }

  if (active.channel === 'event') {
    if (active.threadId && incoming.threadId) {
      return active.threadId === incoming.threadId;
    }
    return Boolean(active.eventId) && active.eventId === incoming.eventId;
  }

  return false;
};
